import { useEffect } from 'react';
import PropTypes from 'prop-types';

const GenesysCloudChat = ({
  firstName,
  lastName,
  profileId,
  facultyIRN,
  email,
  phoneNumber,
  ipAddress,
}) => {
  // Configuration from environment variables
  const getGenesysConfig = () => {
    return {
      environment: process.env.REACT_APP_GENESYS_CLOUD_ENVIRONMENT || 'prod-usw2',
      deploymentId: process.env.REACT_APP_GENESYS_CLOUD_DEPLOYMENT_ID || '1857465a-d763-47bf-b0cd-1bcd4a096c11',
      scriptUrl: process.env.REACT_APP_GENESYS_CLOUD_SCRIPT_URL || 'https://apps.usw2.pure.cloud/genesys-bootstrap/genesys.min.js',
      serviceName: process.env.REACT_APP_GENESYS_CLOUD_SERVICE_NAME || process.env.REACT_APP_CHATBOT_SERVICENAME || 'TACSC Faculty Inbound Chat'
    };
  };

  const getBrowserInfo = () => {
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE', version: tem[1] || '' };
    }

    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR|Edge\/(\d+)/);
      if (tem !== null) {
        return { name: 'Opera', version: tem[1] };
      }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    tem = ua.match(/version\/(\d+)/i);
    if (tem !== null) {
      M.splice(1, 1, tem[1]);
    }

    return {
      name: M[0],
      version: M[1],
    };
  };

  const getOS = (osVal) => {
    if (osVal) {
      if (osVal.includes('Win')) return 'Windows';
      if (osVal.includes('Mac')) return 'Mac';
      if (osVal.includes('Linux')) return 'Linux';
    }
    return '';
  };

  const scrubPhoneNumber = (phoneNumber) => {
    const match = `${phoneNumber}`.replace(/\D/g, '').match(/.{1,10}$/);
    return match ? match[0] : '';
  };

  const handleChatClick = () => {
    const config = getGenesysConfig();
    const browser = getBrowserInfo();
    const customAttributes = {
      sourceURL: window.location.href,
      serviceName: config.serviceName,
      deviceType: navigator.platform,
      IPAddress: ipAddress || '',
      studentFirstName: firstName || '',
      studentLastName: lastName || '',
      studentEmailAddress: email || '',
      studentIRN: facultyIRN || '',
      studentPhoneNumber: scrubPhoneNumber(phoneNumber || ''),
      profileId: profileId || '',
      browserVersion: browser.version,
      browserName: browser.name,
      operatingSystem: getOS(navigator.platform),
      isFaculty: true
    };

    if (window.Genesys) {
      window.Genesys('subscribe', 'Messenger.ready', function (e) {
        window.Genesys('command', 'Messenger.open', {},
          function (o) {
            console.log('Messenger opened.');
          },
          function (o) {
            console.error('Messenger failed to open:', o);
            window.Genesys('command', 'Messenger.close');
            console.log('Messenger closed.');
          }
        );
      });

      window.Genesys('subscribe', 'Database.ready', function (e) {
        window.Genesys('command', 'Database.set', {
          messaging: {
            customAttributes: customAttributes
          }
        },
        function(o) {
          console.log('Database.set succeeded');
        },
        function(error) {
          console.error('Database.set failed:', error);
        });
      });
    }
  };

  useEffect(() => {
    window.openTAC = handleChatClick;
    return () => {
      delete window.openTAC;
    };
  }, []);

  return null; // UI is handled by ChatbotSelector.jsx
};

GenesysCloudChat.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  profileId: PropTypes.string.isRequired,
  facultyIRN: PropTypes.string.isRequired,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  ipAddress: PropTypes.string,
};

GenesysCloudChat.defaultProps = {
  email: '',
  phoneNumber: '',
  ipAddress: '',
};

export default GenesysCloudChat;